import { render, staticRenderFns } from "./RelatedEntitiesLists.vue?vue&type=template&id=86fe5244&scoped=true&"
import script from "./RelatedEntitiesLists.vue?vue&type=script&lang=js&"
export * from "./RelatedEntitiesLists.vue?vue&type=script&lang=js&"
import style0 from "./RelatedEntitiesLists.vue?vue&type=style&index=0&id=86fe5244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe5244",
  null
  
)

export default component.exports